import { render } from "./BGConteudo.vue?vue&type=template&id=1ceaec41"
import script from "./BGConteudo.vue?vue&type=script&lang=js"
export * from "./BGConteudo.vue?vue&type=script&lang=js"

import "./BGConteudo.vue?vue&type=style&index=0&id=1ceaec41&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__